import { GlobalContext } from "components/GlobalContext";
import { useContext, useEffect, useRef } from "react";
import { Button } from "react-bootstrap";
import { LinkContainer } from 'react-router-bootstrap';

const Directory = () => {
  const globalContext = useContext(GlobalContext);
  const globalContextRef = useRef(globalContext);
  globalContextRef.current = globalContext;

  useEffect(() => {
    globalContextRef.current.setSecondaryNav(<></>);
  }, []);

  return (
    <>
      <div className="d-grid gap-2" style={{ marginLeft: "20%", marginRight: "20%" }}>
        {
          globalContext.roles.some(r => r === "Web.FireDepartments") &&
          <LinkContainer to="/Departments">
            <Button variant="primary" size="lg" className="mr-1">
              Fire Departments
            </Button>
          </LinkContainer>
        }
        {
          globalContext.roles.some(r => r === "Web.FireStations") &&
          <LinkContainer to="/Station">
            <Button variant="primary" size="lg" className="mr-1">
              Fire Stations
            </Button>
          </LinkContainer>
        }
        {
          globalContext.roles.some(r => r === "Web.Equipment") &&
          <LinkContainer to="/Equipment">
            <Button variant="primary" size="lg" className="mr-1">
              Equipment
            </Button>
          </LinkContainer>
        }
        <hr />
        {
          globalContext.roles.some(r => r === "Web.Opportunities" || r === "Web.Leads") &&
          <LinkContainer to="/Opportunities">
            <Button variant="primary" size="lg" className="mr-1">
              {globalContext.roles.some(r => r === "Web.Leads") && <>Leads</>} {globalContext.roles.some(r => r === "Web.Opportunities") && globalContext.roles.some(r => r === "Web.Leads") && <>&</>} {globalContext.roles.some(r => r === "Web.Opportunities") && <>Opportunities</>}
            </Button>
          </LinkContainer>
        }
        {
          globalContext.roles.some(r => r === "Web.Demos") &&
          <LinkContainer to="/Demos">
            <Button variant="primary" size="lg" className="mr-1">
              Demos
            </Button>
          </LinkContainer>
        }
        {
          globalContext.roles.some(r => r === "Web.AirCards") &&
          <LinkContainer to="/AirCards">
            <Button variant="primary" size="lg" className="mr-1">
              AirCards
            </Button>
          </LinkContainer>
        }
        {
          globalContext.roles.some(r => r === "Web.HealthRiskAssessments") &&
          <LinkContainer to="/HealthRiskAssessments">
            <Button variant="primary" size="lg" className="mr-1">
              Health Risk Assessments
            </Button>
          </LinkContainer>
        }
        <hr />
        {
          globalContext.roles.some(r => r === "Web.Dealers") &&
          <LinkContainer to="/Dealers">
            <Button variant="primary" size="lg" className="mr-1">
              Dealers
            </Button>
          </LinkContainer>
        }
        {
          globalContext.roles.some(r => r === "Web.SalesRep") &&
          <LinkContainer to="/Reps">
            <Button variant="primary" size="lg" className="mr-1">
              Representatives
            </Button>
          </LinkContainer>
        }
        {
          globalContext.roles.some(r => r === "Web.Contacts") &&
          <LinkContainer to="/Contacts">
            <Button variant="primary" size="lg" className="mr-1">
              Contacts
            </Button>
          </LinkContainer>
        }
        <hr />
        {
          globalContext.roles.some(r => r === "Web.Products") &&
          <LinkContainer to="/Products">
            <Button variant="primary" size="lg" className="mr-1">
              Product Information
            </Button>
          </LinkContainer>
        }
        {
          globalContext.roles.some(r => r === "Web.Tools") &&
          <LinkContainer to="/Tools">
            <Button variant="primary" size="lg" className="mr-1">
              Tool Directory
            </Button>
          </LinkContainer>
        }
        {
          globalContext.roles.some(r => r === "Web.Reports") &&
          <LinkContainer to="/Reports">
            <Button variant="primary" size="lg" className="mr-1">
              Report Directory
            </Button>
          </LinkContainer>
        }
        <LinkContainer to="/FormsDirectory">
          <Button variant="primary" size="lg" className="mr-1">
            Form Directory
          </Button>
        </LinkContainer>
      </div>
    </>
  );
}

export default Directory;
